module.exports = __webpack_public_path__ + "img/icon_listmytools_step2_information.563a1b9f.svg";